import { clearAuthToken } from '@/helpers/authToken'

// Ends the dashboard session. The store is reset only after the login page is
// open, so the page being left never renders against an empty store.
export const signOut = ({ store, router }) => {
  clearAuthToken()
  return router.push('/login').then(() => {
    store.commit('RESET_STATE')
  })
}
